import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ScheduleFormDrawer } from '@/features/schedules/components/schedule-form-drawer'

/**
 * Drawer de Agendar recebimento — FILHO do layout pathless `_receber`, abre por
 * cima da lista. Fechar volta para /recebimentos/receber.
 */
export const Route = createFileRoute('/_authed/recebimentos/_receber/agendar')({
  component: AgendarRecebimento,
})

function AgendarRecebimento() {
  const navigate = useNavigate()
  return (
    <ScheduleFormDrawer
      kind="receivable"
      open
      onOpenChange={(aberto) => {
        if (!aberto) void navigate({ to: '/recebimentos/receber' })
      }}
    />
  )
}
